var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "supplier-contact-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _vm.loading
        ? _c("loading")
        : this.lastRequest
        ? _c("div", [
            _vm._v("\n    Last requested: "),
            _c("b", [
              _vm._v(_vm._s(_vm._f("date")(_vm.lastRequest.createdAt))),
            ]),
          ])
        : _vm._e(),
      _c("validated-input", {
        attrs: { label: "Name", validate: "required|max:1000" },
        model: {
          value: _vm.name,
          callback: function ($$v) {
            _vm.name = $$v
          },
          expression: "name",
        },
      }),
      _c("validated-input", {
        attrs: { label: "Company", validate: "required|max:1000" },
        model: {
          value: _vm.company,
          callback: function ($$v) {
            _vm.company = $$v
          },
          expression: "company",
        },
      }),
      _c("validated-input", {
        attrs: { label: "Email", validate: "required|max:1000" },
        model: {
          value: _vm.email,
          callback: function ($$v) {
            _vm.email = $$v
          },
          expression: "email",
        },
      }),
      _c("validated-input", {
        attrs: { label: "Phone" },
        model: {
          value: _vm.phone,
          callback: function ($$v) {
            _vm.phone = $$v
          },
          expression: "phone",
        },
      }),
      _c("validated-input", {
        attrs: { label: "Block Id", validate: "required|max:1000" },
        model: {
          value: _vm.blockId,
          callback: function ($$v) {
            _vm.blockId = $$v
          },
          expression: "blockId",
        },
      }),
      _c("validated-input", {
        attrs: { label: "Company Id", validate: "required|max:1000" },
        model: {
          value: _vm.companyId,
          callback: function ($$v) {
            _vm.companyId = $$v
          },
          expression: "companyId",
        },
      }),
      _c("div", { staticClass: "form-group mt-3" }, [
        _c("label", [_vm._v("Message")]),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.message,
              expression: "message",
            },
          ],
          staticClass: "form-control",
          attrs: {
            type: "text",
            placeholder: "message...",
            autofocus: "",
            rows: "10",
          },
          domProps: { value: _vm.message },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.message = $event.target.value
            },
          },
        }),
      ]),
      _c(
        "button",
        {
          staticClass: "btn btn-primary mt-3 mb-4",
          attrs: { disabled: _vm.errors.any() || _vm.submitting },
          on: { click: _vm.request },
        },
        [
          _vm.submitting
            ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
            : _vm._e(),
          _vm._v(" Submit\n  "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }